import { render, staticRenderFns } from "./CoachBlock.vue?vue&type=template&id=77515863"
import script from "./CoachBlock.vue?vue&type=script&lang=ts"
export * from "./CoachBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports